function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#EDEDED"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.90952 15H9.63489C9.8614 15 10.0444 14.8157 10.0444 14.5892C10.0444 14.3627 9.8614 14.1797 9.63489 14.1797H6.31904V5.81904H13.7634V9.94625C13.7634 10.1728 13.9464 10.3558 14.1729 10.3558C14.3994 10.3558 14.5824 10.1728 14.5824 9.94625V5.40952C14.5824 5.183 14.3994 5 14.1729 5H5.90952C5.683 5 5.5 5.183 5.5 5.40952V14.5905C5.5 14.817 5.683 15 5.90952 15ZM10.3954 8.9699L6.89911 8.98986L6.90378 9.8089L10.4001 9.78894L10.3954 8.9699ZM9.56414 10.8423L6.89969 10.8623L6.90584 11.6813L9.57029 11.6613L9.56414 10.8423ZM12.8223 7.09417L6.90085 7.12092L6.90456 7.93996L12.826 7.91322L12.8223 7.09417ZM12.2149 14.3755C11.0272 14.3755 10.061 13.4093 10.061 12.2217C10.061 11.0341 11.0272 10.0679 12.2149 10.0679C13.4025 10.0679 14.3687 11.0341 14.3687 12.2217C14.3687 12.6787 14.2254 13.1029 13.9816 13.4519L14.7117 14.1553C14.8742 14.3127 14.8793 14.5712 14.7219 14.7337C14.6426 14.8182 14.5351 14.8591 14.4276 14.8591C14.3252 14.8591 14.2228 14.8207 14.1435 14.744L13.3947 14.0225C13.0554 14.2456 12.6498 14.3755 12.2149 14.3755ZM12.2149 10.8869C11.479 10.8869 10.8801 11.4858 10.8801 12.2217C10.8801 12.9576 11.479 13.5565 12.2149 13.5565C12.9507 13.5565 13.5496 12.9576 13.5496 12.2217C13.5496 11.4858 12.9494 10.8869 12.2149 10.8869Z",
  fill: "#4F4F4F"
});

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.cea57fb9.svg";
export { ForwardRef as ReactComponent };